module.exports = __webpack_public_path__ + "img/folder-4.5f5f4c9d.png";